

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from './ImpactSettings.css';
import withStyles from '../../decorators/withStyles';


class ImpactSettings extends Component {

  static propTypes = {
    className: PropTypes.string,
    showProtection: PropTypes.bool
  };

  static defaultProps = {
    showProtection: true
  };

  render() {
    return (
      <div className={this.props.className}>
        <h2>Show threats by</h2>
        <label title="">
          <input name={"impactPct " + this.props.className} type="radio"
                 value="false"
                 onChange={this.props.handleImpactPctChange} checked={!this.props.impactPct} />Total that could be affected</label>
        <label title="">
          <input name={"impactPct " + this.props.className}  type="radio"
                 value="true"
                 onChange={this.props.handleImpactPctChange} checked={this.props.impactPct} />Percentage that could be affected</label>
        {this.props.showProtection ?
          <div>
          <br />
          <h2>Protected or isolated areas</h2>
            <p>Areas that available data suggest are protected by levees or other features, including natural ridges, should be: </p>
          <label title="Some areas are protected by levees or isolated. Adjust for this in the analysis.">
            <input name={"levees " + this.props.className} type="radio"
                   value="true"
                   onChange={this.props.handleProtectionChange} checked={this.props.protection === "protected"} />excluded from threat calculations</label>
          <label title="Some areas are protected by levees or isolated. Adjust for this in the analysis.">
            <input name={"levees " + this.props.className} type="radio"
                   value="false"
                   onChange={this.props.handleProtectionChange} checked={this.props.protection === "unprotected"} />included in threat calculations</label>
        </div> : null}
      </div>
    );
  };

}

export default withStyles(styles)(ImpactSettings);
